/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, ElementRef,AfterViewInit } from '@angular/core';
import { LayoutBaseComponent } from '../layout-base.component';

@Component({
  selector: 'notice-box',
  templateUrl: './notice-box.component.html',
  styleUrls: ['./notice-box.component.less']
})
export class NoticeBoxComponent extends LayoutBaseComponent implements AfterViewInit {
      constructor( private elRef:ElementRef) { super(); 
                   this.textClass = "ontario-notice";
      }

      public get inputClass():string {
             return "ontario-notice-icon icon-center  " + this.input_class;
      }

      public get labelClass():string {
            return this.label_class;
      }


      public get className():string {
             return "notice-box "+this.class_name;
      }

      public ngAfterViewInit() {
             let myDiv = this.elRef.nativeElement.querySelector('.notice-box');
             super.layoutFromViewInit(myDiv);
      }
}
